<template>
  <div>
    <div class="system" @click="ischecksystem = !ischecksystem">
      <div class="head">
        <img src="../../../assets/zx/syetem.png" alt="" />
      </div>
      <div style="flex: 1">
        <p class="t-name">系统匹配老师</p>
        <p class="user-num">{{ data.pcid && data.pcid.num }}位用户选择</p>
      </div>
      <div class="system-select">
        <div class="price" v-if="data.answers">
          ￥{{ data.pcid && data.pcid.price }}
        </div>
        <div class="price" v-else>￥{{ data.id.price }}</div>
        <div
          :class="ischecksystem ? 'radio-check' : 'radio'"
          style="margin-top: 0.28rem"
        ></div>
      </div>
    </div>

    <list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <!-- <div class="teacher" @click="ischecksystem = !ischecksystem">
        <div class="teacher-info">
          <div class="teacher-head">
            <img
              src="@/assets/user.png"
              alt=""
              style="width:100%;height:100%"
            />
          </div>
          <div class="right-info" style="justify-content: center;display: flex;flex-direction: column;">
            <div class="n-p">
              <div class="t-d">
                <div class="teacher-name" style="font-weight:normal">
                  系统匹配老师
                </div>
              </div>
              <div class="price">
                <span>￥{{ serTeacher.p }}</span
                ><small>起</small>
              </div>
            </div>
            <div class="select-t select-t1">
              <div class="num" style="color:#999">
                {{ serTeacher.num }}位用户选择
              </div>
              <div :class="ischecksystem ? 'radio-check' : 'radio'"></div>
            </div>
          </div>
        </div>
      </div> -->
      <div
        class="teacher"
        v-for="(item, index) in list"
        :key="index"
        @click="selectTeacher(item, 1)"
      >
        <div class="teacher-info">
          <div class="teacher-head">
            <van-image
              fit="cover"
              width="100%"
              height="100%"
              :src="item.avatar"
              alt=""
            />
          </div>
          <div class="right-info">
            <div class="n-p">
              <div class="t-d">
                <div class="teacher-name">{{ item.username }}</div>
                <div class="star">
                  <stars :num="item.quality" />
                  <span>{{ item.quality }}</span>
                </div>
              </div>
              <div class="price">
                <span>￥{{ item.price }}</span
                ><small>起</small>
              </div>
            </div>
            <div class="lable">
              <div v-for="(tag, i) in item.mode" :key="i">{{ tag }}</div>
            </div>
          </div>
        </div>
        <div class="explain">
          {{ item.introduction }}
        </div>
        <div class="select-t">
          <div class="num">解答：{{ item.answers }}</div>
          <div
            :class="item.checked ? 'radio-check' : 'radio'"
            v-if="item.num"
          ></div>
          <div class="tips" v-else>今日订单已满</div>
        </div>
        <!-- <div class="three">
          <div>
            <i class="iconfont icon-pinglun"></i>
            <span>123</span>
          </div>
          <div>
            <i class="iconfont icon-hua"></i>
            <span>123</span>
          </div>
          <div>
            <i class="iconfont icon-guanzhu"></i>
            <span>123</span>
          </div>
        </div> -->
      </div>
    </list>
    <div style="height: 50px"></div>
    <div class="footer">
      <div class="tw" @click="putQuestions">提问</div>
    </div>
  </div>
</template>

<script>
/**
@description:选择老师
@createTime:2021-08-23
@create:wq
*/
import { List } from "vant";
import stars from "@/components/stars";
export default {
  name: "",
  props: {},
  components: { List, stars },
  data() {
    return {
      loading: false,
      finished: true,
      data: "",
      list: [],
      ischecksystem: false,
      checked: false,
      serTeacher: {},
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    const data = JSON.parse(localStorage.getItem("order"));
    if (data) {
      this.data = data;
      this.answersTeacher();
    }
    // console.log(this.$route.query);
    this.serTeacher = this.$route.query;
  },
  methods: {
    answersTeacher() {
      const id = this.data.pcid.id;
      const pid = this.data.answers ? 0 : this.data.id.id;
      this.api.answersTeacher({ id, pid }).then((res) => {
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
          this.finished = false;
        }
      });
    },
    onLoad() {
      this.page++;
      this.answersTeacher();
    },
    selectTeacher(item, t) {
      if (item.checked) {
        item.checked = false;
      } else {
        item.checked = true;
      }
      this.$forceUpdate();
    },
    putQuestions() {
      const st = [];
      if (this.ischecksystem) {
        let price = 0;
        if (this.data.answers) {
          price = this.data.pcid.price;
        } else {
          price = this.data.id && this.data.id.price;
        }
        st.push({ id: 0, price: price, username: "系统匹配老师",checked:true });
      }
      const arr = this.list.filter((o) => o.checked);
      st.push(...arr);
      if (st.length) {
        localStorage.setItem("st", JSON.stringify(st));
        this.$router.push({ path: "/orderConfirm", query: { s: 2 } });
      } else {
        this.Toast("请选择老师");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.system {
  height: 1.62rem;
  background: #ffffff;
  border-bottom: 0.12rem solid #f1f1f1;
  display: flex;
  align-items: center;
  padding: 0 0.24rem;
  .head {
    width: 1.26rem;
    height: 1.26rem;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 0.18rem;
    img {
      width: 100%;
    }
  }
  .system-select {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .t-name {
    font-size: 0.3rem;
    color: #333333;
  }
  .user-num {
    font-size: 0.22rem;
    font-weight: 500;
    color: #999999;
    margin-top: 0.22rem;
  }
}
.price {
  font-size: 0.32rem;
  font-weight: 400;
  color: #f05468;
}

// .radio {
//   width: 0.32rem;
//   height: 0.32rem;
//   background: #f5f5f5;
//   border: 1px solid #e6e6e6;
//   border-radius: 50%;
//   flex-shrink: 0;
// }
// .radio-checked {
//   width: 0.32rem;
//   height: 0.32rem;
//   background: #4fd9d5;
//   border: 1px solid #aaefed;
//   border-radius: 50%;
//   flex-shrink: 0;
// }

.teacher {
  padding: 0.38rem 0.24rem 0.22rem;
  border-bottom: 0.12rem solid #f1f1f1;
  .teacher-info {
    display: flex;

    .teacher-head {
      width: 1.28rem;
      height: 1.28rem;
      border: 2px solid #ffffff;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 0.16rem;
      img {
        width: 100%;
      }
    }

    .right-info {
      flex: 1;
      .n-p {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .teacher-name {
          font-size: 0.32rem;
          font-weight: bold;
          color: #333333;
        }
        .star {
          display: flex;
          align-items: center;
          i {
            font-size: 0.3rem;
            color: #cccccc;
            margin-right: 3px;
          }
          span {
            font-size: 0.28rem;
            font-weight: 500;
            color: #f07954;
            margin-left: 3px;
          }
        }
        .price {
          font-size: 0.2rem;
          font-weight: 400;
          color: #f05468;
          span {
            font-size: 0.32rem;
          }
          small {
            display: inline-block;
            transform: scale(0.8);
          }
        }
      }
      .lable {
        display: flex;
        flex-wrap: wrap;
        margin-top: 0.14rem;

        > div {
          height: 0.36rem;
          background: #ffeedf;
          border-radius: 0.22rem;
          font-size: 0.2rem;
          font-weight: 400;
          color: #ffa380;
          padding: 0 0.2rem;
          margin-right: 5px;
          margin-bottom: 5px;
        }
      }
    }
  }
  .explain {
    font-size: 0.28rem;
    color: #666666;
    margin-top: 0.3rem;
  }
  .select-t {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0.3rem 0;
    &.select-t1 {
      margin-top: 0.2rem;
      margin-bottom: 0;
    }
    .num {
      font-size: 0.26rem;
      color: #333333;
    }
    .tips {
      color: #f05468;
      font-size: 12px;
    }
  }
}
.footer {
  width: 7.5rem;
  height: 50px;
  background: #f6f6f6;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  .tw {
    width: 100%;
    height: 40px;
    background: #4fd9d5;
    box-shadow: 0px 3px 6px rgba(79, 217, 213, 0.3);
    border-radius: 20px;
    font-size: 15px;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    margin: 0 12px;
  }
}
</style>
